"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSessionTimeout = exports.checkSessionTimeout = void 0;
/**
 * Checks if the session has timed out based on the session start time and the current time.
 * If the session has timed out, the provided callback function is called.
 *
 * @param {Object} params - The parameters object.
 * @param {Dispatch<AnyAction>} params.dispatch - The dispatch function to send actions to the Redux store.
 * @param {Dispatch<AnyAction>} params.setIsSessionValid - The redux handler to set session validity.
 * @param {string} sessionStartTime - The ISO string representing the session start time.
 */
var checkSessionTimeout = exports.checkSessionTimeout = function checkSessionTimeout(_ref, sessionStartTime) {
  var dispatch = _ref.dispatch,
    setIsSessionValid = _ref.setIsSessionValid;
  /**
   * SESSION_EXP_DURATION_IN_SECONDS is treated as feature flag for the session expiry feature.
   * If the SESSION_EXP_DURATION_IN_SECONDS environment is not set then checkSessionTimeout
   * function will leave the session redux slice to the initial state that means session will
   * never expire for the user.
   */
  if (!process.env.SESSION_EXP_DURATION_IN_SECONDS) {
    // eslint-disable-next-line no-console
    console.log('Session Expiry feature is not enable for this build.');
    return true;
  }

  /**
   * Only check the session validity if the session start time is set before.
   */
  if (sessionStartTime) {
    var currentTime = new Date();
    var startTime = new Date(sessionStartTime);
    var timeDifferenceInSeconds = (currentTime - startTime) / 1000;
    if (timeDifferenceInSeconds >= process.env.SESSION_EXP_DURATION_IN_SECONDS) {
      dispatch(setIsSessionValid(false));
      return false;
    }
  }
  dispatch(setIsSessionValid(true));
  return true;
};

/**
 * Sets the session start time.
 * Dispatches the setSessionStartTime action with the current time as the session start time.
 *
 * @param {Object} params - The parameters object.
 * @param {Dispatch<AnyAction>} params.dispatch - The dispatch function to send actions to the Redux store.
 * @param {Function} params.setSessionStartTime - The action to set the session start time.
 */
var setSessionTimeout = exports.setSessionTimeout = function setSessionTimeout(_ref2) {
  var dispatch = _ref2.dispatch,
    setSessionStartTime = _ref2.setSessionStartTime;
  var startTime = new Date().toISOString();
  dispatch(setSessionStartTime(startTime));
};